import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const Qualification = ({ roles }) => {

    return (
        <M_Table entityName={'Qualification'} filtersOnTable rolePermissions={roles} />
    )
}